export default data => {
    const { ids, userId } = data;
    const rtbhEvents = window.rtbhEvents || [];
    rtbhEvents.push({ eventType: 'basketstatus', offerIds: ids }, { eventType: 'uid', id: userId });
}